import { call, put } from 'redux-saga/effects'
import { getInterviewRequestEventFeedbacks, postInterviewRequestEventFeedback } from '../apiModules/interviewRequestEventFeedbacks'
import { interviewRequestEventFeedbackEntities } from '../reducks'

export function* fetchInterviewRequestEventFeedbackEntitiesSaga(interviewRequestId, params) {
  const response = yield call(getInterviewRequestEventFeedbacks, interviewRequestId, params)
  yield put(interviewRequestEventFeedbackEntities.addCollection(response.result))
  return response
}

export function* createInterviewRequestEventFeedbackEntitySaga(interviewRequestId, data) {
  const response = yield call(postInterviewRequestEventFeedback, interviewRequestId, data)
  yield put(interviewRequestEventFeedbackEntities.addItem(response.result.id, response.result))
  return response
}
